class LineItemQuantity extends HTMLElement {
	connectedCallback() {
		this.lineItemNode = this.closest('.order-form__product-item');
		this.qtyInput = this.querySelector('.js-qty__num');
		this.minusButton = this.querySelector('.js-qty__adjust--minus');
		this.plusButton = this.querySelector('.js-qty__adjust--plus');
		this.qtyInput.addEventListener('input', this.onInputChange.bind(this));
		this.minusButton.addEventListener('click', this.onMinusClick.bind(this));
		this.plusButton.addEventListener('click', this.onPlusClick.bind(this));
		this.orderForm = this.closest('order-form');
	}
	disconnectedCallback() {
		this.qtyInput.removeEventListener('input', this.onInputChange.bind(this));
		this.minusButton.removeEventListener('click', this.onMinusClick.bind(this));
		this.plusButton.removeEventListener('click', this.onPlusClick.bind(this));
	}
	get value() {
		return {
			width: parseInt(this.dataset.width, 10),
			height: parseInt(this.dataset.height, 10),
			depth: parseInt(this.dataset.depth, 10),
			variantID: parseInt(this.dataset.variantId, 10),
			price: parseFloat(this.dataset.price),
			imageUrl: this.dataset.imageUrl,
			color: this.dataset.color,
			category: this.dataset.category?.toUpperCase(),
			quantity: parseInt(this.qtyInput.value, 10),
		};
	}
	get variantID() {
		return parseInt(this.dataset.variantId, 10);
	}
	get couldFit() {
		return !this.lineItemNode.classList.contains('hide');
	}
	initWithLocalStorage(quantity) {
		if (quantity && quantity > 0) {
			this.qtyInput.value = quantity;
		} else {
			this.qtyInput.value = 0;
		}
	}
	updateAddingLineItemButton(doesOneMoreFit) {
		if (doesOneMoreFit) {
			this.plusButton.classList.remove('disabled');
		} else {
			this.plusButton.classList.add('disabled');
		}
	}
	onInputChange(event) {
		const value = parseInt(event.target.value, 10);
		// TODO: ENSURE THAT THE VALUE IS MINIMIZED TO smallest possible value
		if (isNaN(value) || value < 0) {
			event.target.value = 0;
		} else {
			event.target.value = value;
		}
		this.orderForm.dispatchEvent(new CustomEvent('line-item-quantity:change'));
	}
	onMinusClick(event) {
		event.preventDefault();
		const input = this.qtyInput;
		let value = parseInt(input.value, 10);
		if (isNaN(value) || value <= 0) {
			value = 0;
		} else {
			value -= 1;
		}
		input.value = value;
		this.orderForm.dispatchEvent(new CustomEvent('line-item-quantity:change'));
	}
	onPlusClick(event) {
		if (this.plusButton.classList.contains('disabled')) {
			this.dispatchEvent(
				new CustomEvent('tooltip:open', {
					detail: {
						context: this.plusButton.dataset.tooltipContext,
						content: this.plusButton.dataset.tooltipContent,
					},
					bubbles: true,
				}),
			);
			return;
		}
		const input = this.qtyInput;
		let value = parseInt(input.value, 10);
		if (isNaN(value) || value < 0) {
			value = 1;
		} else {
			value += 1;
		}
		input.value = value;
		this.orderForm.dispatchEvent(new CustomEvent('line-item-quantity:change'));
	}
	hide() {
		this.lineItemNode.classList.add('hide');
		this.classList.add('disabled');
	}
	show() {
		this.lineItemNode.classList.remove('hide');
		this.classList.remove('disabled');
	}
	reset() {
		this.qtyInput.value = 0;
		this.orderForm.dispatchEvent(new CustomEvent('line-item-quantity:change'));
	}
}
customElements.define('line-item-quantity', LineItemQuantity);
